(function () {
  'use strict';

  class RiskIntelligenceDetailCtrl {
    constructor(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $state, $stateParams) {
      this.safetyService = safetyService;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.authenticator = Authenticator;
      this.blockUI = blockUI;
      this.state = $state;
      this.stateParams = $stateParams;

      this.user = null;

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    // The detail has no filters: an empty init hides the filter bar left by the board.
    initFilter() {
      return this.serviceVfiltro.init(this.factoryVfiltro.get([]));
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './RiskIntelligenceDetailPageRoute',
          componentId = 'safety-app-risk-intelligence-detail',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    goBackToBoard() {
      this.state.go('root.riskIntelligence');
    }

    getReactProps() {
      return {
        user: this.user,
        ocorrenciaId: this.stateParams.id,
        dataHoraReferencia: this.stateParams.dataHoraReferencia,
        alertaId: this.stateParams.alertaId,
        goBackToBoard: () => this.goBackToBoard()
      };
    }
  }

  RiskIntelligenceDetailCtrl.$inject = ['safetyService', 'ServiceVfiltro', 'FactoryVfiltro', 'Authenticator', 'blockUI', '$state', '$stateParams'];
  angular.module('relatorios.riskIntelligence').controller('RiskIntelligenceDetailCtrl', RiskIntelligenceDetailCtrl);
}());
